"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureArray = ensureArray;

var _ramda = require("ramda");

function ensureArray(maybeArr) {
  if (Array.isArray(maybeArr)) {
    return maybeArr;
  }

  if ((0, _ramda.isNil)(maybeArr)) {
    return [];
  }

  return [maybeArr];
}